<app-input-wrapper [control]="control">
  @if (label) {
    <label class="period-label">
      {{ label }}
      @if (requiredMarker) {
        <span class="required-marker">{{ requiredMarker }}</span>
      }
    </label>
  }
  <button class="button icon-button" type="button" (click)="onSelectPrev()">
    <app-icon [name]="'ic_chevron_left'" />
  </button>
  @if (isDaily) {
    <input
      class="period-input"
      type="date"
      [value]="dailyValue"
      [max]="maxDailyValue"
      [disabled]="control.disabled"
      (change)="onDailyChange($event)"
    />
  } @else if (isMonthly) {
    <input
      class="period-input"
      type="month"
      [value]="monthlyValue"
      [max]="maxMonthlyValue"
      [disabled]="control.disabled"
      (change)="onMonthlyChange($event)"
    />
  } @else {
    <select
      class="period-input"
      [disabled]="control.disabled"
      [value]="yearlyValue"
      (change)="onYearChange($event)"
    >
      @for (year of years; track year) {
        <option [value]="year">{{ year }}</option>
      }
    </select>
  }
  <button
    class="button icon-button"
    type="button"
    [disabled]="!canSelectNext"
    (click)="onSelectNext()"
  >
    <app-icon [name]="'ic_chevron_right'" />
  </button>
</app-input-wrapper>
